import React from 'react';
import { useNavigate } from 'react-router-dom';
import products from 'data/can-store/products';
import ModernProductCard from './ModernProductCard';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';

function ModernHomeProducts() {
	const navigate = useNavigate();

	return (
		<Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
			<Stack direction="row" justifyContent="space-between">
				<Typography variant="h4" style={{ color: 'var(--csmd-cl-text-primary)' }}>
					All Products
				</Typography>
				<Button
					variant="text"
					endIcon={<ArrowRightIcon />}
					sx={{ textTransform: 'none', color: 'var(--csmd-cl-border-primary)', fontWeight: 'bold' }}
					onClick={() => navigate('/products')}
				>
					View all
				</Button>
			</Stack>
			<Grid container spacing={3}>
				{products.map((product) => (
					<Grid item xs={3} key={product.id}>
						<ModernProductCard product={product} />
					</Grid>
				))}
			</Grid>
			<Button
				variant="contained"
				endIcon={<KeyboardDoubleArrowDownIcon />}
				color="primary"
				sx={{
					width: '200px',
					margin: 'auto',
					marginTop: '2rem',
					marginBottom: '1.5rem',
				}}
			>
				Show more
			</Button>
		</Box>
	);
}

export default ModernHomeProducts;
